





































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import Hover from "./hover.vue";
@Component({
  components: {
    Hover
  }
})
export default class ProjectThirdControlBiaoti extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  private ifShowConfig: boolean = false;
  private temp: any = {};
  /**
   * @description 打开配置弹窗
   */
  private openConfigDialg() {
    this.temp = _.cloneDeep(this.ziduan);
    this.ifShowConfig = true;
  }
  /**
   * @description 保存
   */
  private save() {
    // 检查标题
    if (!this.temp.content.title) {
      this.$message.warning("标题名称不能为空");
      return;
    }
    this.$emit("ziduanChange", this.temp);
    this.ifShowConfig = false;
  }
  /**
   * @description 取消/关闭弹窗
   */
  private closeDialog() {
    this.temp = {};
    this.ifShowConfig = false;
  }
  /**
   * @description 删除这个字段
   */
  private deleteThis() {
    this.$emit("del");
  }
}
